import { useCallback } from 'react';
import { useLang } from 'hooks/lang';

import { ProjectType } from 'entities';

import { LabeledSelect } from 'components/Blocks';
import { SquareMouseIcon } from 'components/Icons';

import { TrackerOrigin } from './TrackerOrigin';
import { TrackerSequence } from './TrackerSequence';

import { CreateProjectDispatchAction, ProjectTypeConfig } from '../../types';

import { PROJECT_TYPE_OPTIONS } from 'utils/constants';

import { cn } from 'styles';

export interface ProjectTypeProps {
  projectType: ProjectTypeConfig;
  dispatch: CreateProjectDispatchAction;
}

const especialCases: { [key in ProjectType]?: (props: ProjectTypeProps) => JSX.Element } = {
  TRACKER_ORIGIN: TrackerOrigin,

  TRACKER_SEQUENCE: TrackerSequence,
};

export function ProjectTypeRenderer({ projectType, dispatch }: ProjectTypeProps): JSX.Element {
  const { t } = useLang();

  const isEspecial = projectType.type in especialCases;

  const EspecialComponent = isEspecial && especialCases[projectType.type as ProjectType];

  const handleTypeChange = useCallback(
    (type: string) => {
      dispatch({ typeConfig: { type: type as ProjectType } });
    },
    [dispatch],
  );

  return (
    <div className={cn('col-span-2 grid gap-6 phone:col-span-1', isEspecial ? 'grid-cols-2' : '')}>
      <LabeledSelect
        value={projectType.type}
        onChangeDirect={handleTypeChange}
        label={t('project-type-capitalized') || ''}
        labelIcon={SquareMouseIcon}
        options={PROJECT_TYPE_OPTIONS.map(({ value, getLabel }) => ({
          value,
          label: getLabel(t),
        }))}
      />

      {EspecialComponent && <EspecialComponent projectType={projectType} dispatch={dispatch} />}
    </div>
  );
}
